import { ContingencyGeocercaItem } from "./contingency-geocerca-item.model";
import { ContingencyItem } from "./contingency-item.model";

export class Contingency {
    id: string
    filters: ContingencyItem[];
    geocerca: ContingencyGeocercaItem
    fleet: string
}
